import OptimizerEditDto from "./OptimizerEditDto";

export class ConjugateGradientOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.gtol = null;
        /** @type {number} */
        this.norm = null;
        /** @type {number} */
        this.c1 = null;
        /** @type {number} */
        this.c2 = null;
        /** @type {number} */
        this.eps = null;
    }

    /**
     * @typedef {Object} _ConjugateGradientOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} gtol
     * @property {numebr} norm
     * @property {number} c1
     * @property {number} c2
     * @property {number} eps
     * 
     * @typedef {import('./OptimizerEditDto'.OptimizerEditDtoProps & _ConjugateGradientOptimizerEditDtoProps) ConjugateGradientOptimizerEditDtoProps}
     */
    /**
     * @param {ConjugateGradientOptimizerEditDtoProps} props
     * @returns {ConjugateGradientOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.gtol = props.gtol;
        this.norm = props.norm;
        this.c1 = props.c1;
        this.c2 = props.c2
        this.eps = props.eps;
        return this;
    }
}

export default ConjugateGradientOptimizerEditDto;